import { computed, makeObservable } from 'mobx'

import { ModelWithPolicy } from 'modules/core/lib/modelWithPolicy'
import accessGroups from 'modules/core/store/collections/accessGroups'
import type AccessGroup from 'modules/core/store/models/AccessGroup'
import PostsGroupPolicy from 'modules/core/store/models/policies/PostsGroupPolicy'

interface IGroup {
  [key: string]: any
}

class Group extends ModelWithPolicy<IGroup> {
  static urlRoot() {
    return '/posts/groups'
  }

  constructor(attr: IGroup = {}) {
    super(attr)
    makeObservable(this, {
      accessGroup: computed,
      isDefault: computed,
    })
  }

  get policy() {
    return new PostsGroupPolicy(this)
  }

  get accessGroup(): AccessGroup | null | undefined {
    return accessGroups.find({
      id: this.attributes.access_group_id,
    })
  }

  get isDefault(): boolean {
    return !!this.attributes.default
  }
}

export default Group
